// Public OAuth consent page (the api mcp() plugin's `consentPage`). Single
// top-level segment for the same base "./" reason as /oauth-sign-in. Rendered
// without AuthGuard: the page handles a missing session itself.

import { createFileRoute } from '@tanstack/react-router';

import { OAuthConsentPage } from '../components/oauth/OAuthConsentPage';

export const Route = createFileRoute('/oauth-consent')({
    component: OAuthConsentPage,
});
